
import { CreateDashboardComponent } from "./components/create-dashboard.component";
import { ViewDashboardComponent } from "./components/view-dashboard.component";
import { EditDashboardComponent } from "./components/edit-dashboard.component";
import { DashboardResolver } from "./services/dashboard.resolver";
import { DashboardCreateResolver } from "./services/dashboard-create.resolver";
import { BaseGuardService } from "../auth/guards/base-guard.service";
import { ViewDashGuardService } from "../auth/guards/view-dash-guard.service";
import { SystemPermissionGuardService } from "../auth/guards/system-permission-guard.service";
import { LunaClaimValues } from "../models/user-identity.model";
import { Route, mapToCanActivate, mapToResolve, mapToCanDeactivate } from "@angular/router";
import { WidgetExpandedViewComponent } from "./components/widgets/widget-expanded-view/widget-expanded-view.component";
import { WellResolver } from "../wells/resolvers/well.resolver";
import { OrganizationResolver } from "../common/resolvers/organization.resolver";
import { OrganizationWellDetailsComponent } from "../common/components/organization/components/organization-well-details/organization-well-details.component";
import { PendingWellTransferWidgetComponent } from "./components/widgets/well-widget/pending-well-transfer-widget.component";
import { WellTransferSellerWidgetComponent } from "./components/widgets/well-widget/well-transfer-seller-widget.component";
import { WellTransferBuyerWidgetComponent } from "./components/widgets/well-widget/wt-buyer-widget.component";
import { MasterGuardService } from "../auth/guards/master-guard.service";
import { GuardList } from "../auth/guards/guard-list.enum";

const existingDashGuards = [BaseGuardService, ViewDashGuardService];
const editDashGuards = [BaseGuardService, SystemPermissionGuardService];

export const DASHBOARD_ROUTES: Route[] = [
    {
        path: "create",
        component: CreateDashboardComponent,
        canActivate: mapToCanActivate(editDashGuards),
        data: { permission: LunaClaimValues.ManageDashboards }
    },
    {
        path: "create/:moduleGroupId/:moduleId",
        component: CreateDashboardComponent,
        resolve: { dashboard: mapToResolve(DashboardCreateResolver) },
        canActivate: mapToCanActivate(editDashGuards),
        data: { permission: LunaClaimValues.ManageDashboards }
    },
    {
        path: "view",
        component: WidgetExpandedViewComponent,
        children: [
            {
                path: "well/:id",
                component: OrganizationWellDetailsComponent,
                resolve: { well: mapToResolve(WellResolver), organization: mapToResolve(OrganizationResolver) },
                data: { guards: [ GuardList.BaseGuardService ] },
                canActivate: mapToCanActivate([MasterGuardService])
            }
        ]
    },
    {
        path: "view/:dashboardid",
        component: ViewDashboardComponent,
		resolve: { dashboard: mapToResolve(DashboardResolver) },
        canActivate: existingDashGuards
    },   
    {
        path: "edit/:dashboardid",
        component: EditDashboardComponent,
		resolve: { dashboard: mapToResolve(DashboardResolver) },
        canActivate: mapToCanActivate(editDashGuards),
        data: { permission: LunaClaimValues.ManageDashboards }
    },
    {
        path: ":dashboardid",
        component: ViewDashboardComponent,
        resolve: { dashboard: mapToResolve(DashboardResolver) },
        data: { guards: [ GuardList.BaseGuardService, GuardList.ViewDashGuardService] },
        canActivate: mapToCanActivate([MasterGuardService])
    },
    {
        path: "view",
        component: PendingWellTransferWidgetComponent,
        canActivate: mapToCanActivate(editDashGuards),
        data: { permission: LunaClaimValues.ViewPendingWellTransferWidget }
    },
    {
        path: "well-transfer-seller",
        component: WellTransferSellerWidgetComponent,
        canActivate: mapToCanActivate([SystemPermissionGuardService]),          
        data: { permission: LunaClaimValues.ViewWellSellerTransferWidget }
    },    

    {
        path: "wt-buyer",
        component: WellTransferBuyerWidgetComponent,
        canActivate: mapToCanActivate([SystemPermissionGuardService]),
        data: { permission: LunaClaimValues.ViewWellBuyerTransferWidget}
    }     
]